import {concat, isNil, pull} from 'lodash';
import {TreeviewItem} from "../models/treeview-item";


export class MyTreeHelper{

static findItem(root: TreeviewItem, value: any): TreeviewItem | undefined {
  if (isNil(root)) {
    return undefined;
  }

  if (root.value === value) {
    return root;
  }

  if (root.children) {
    for (const child of root.children) {
      const foundItem = this.findItem(child, value);
      if (foundItem) {
        return foundItem;
      }
    }
  }

  return undefined;
}

  static findItemInList(list: TreeviewItem[], value: any): TreeviewItem | undefined {
  if (isNil(list)) {
    return undefined;
  }

  for (const item of list) {
    const foundItem = this.findItem(item, value);
    if (foundItem) {
      return foundItem;
    }
  }

  return undefined;
}

  static  findParent(root: TreeviewItem, item: TreeviewItem): TreeviewItem | undefined {
  if (isNil(root) || isNil(root.children)) {
    return undefined;
  }

  for (const child of root.children) {
    if (child === item) {
      return root;
    } else {
      const parent = this.findParent(child, item);
      if (parent) {
        return parent;
      }
    }
  }

  return undefined;
}

static removeItem(root: TreeviewItem, item: TreeviewItem): boolean {
  const parent = this.findParent(root, item);
  if (parent) {
    pull(parent.children, item);
    if (parent.children.length === 0) {
      parent.children = undefined;
    } else {
      parent.correctChecked();
    }
    return true;
  }

  return false;
}

  static concatSelection(items: TreeviewItem[], checked: TreeviewItem[], unchecked: TreeviewItem[]): { [k: string]: TreeviewItem[] } {
  let checkedItems = [...checked];
  let uncheckedItems = [...unchecked];
  for (const item of items) {
    const selection = item.getSelection();
    checkedItems = concat(checkedItems, selection.checkedItems);
    uncheckedItems = concat(uncheckedItems, selection.uncheckedItems);
  }
  return {
    checked: checkedItems,
    unchecked: uncheckedItems
  };
}
}
